import { ItensPerfilTypes } from '../../../../../../services/perfil'

export const limparPermissoesPerfil = (perfis: ItensPerfilTypes[]) => {
  return perfis.map((perfil) => {
    return {
      ...perfil,
      permissoes: perfil.permissoes.filter(
        (perm) =>
          perm.inclusao === 1 || perm.exclusao === 1 || perm.alteracao === 1 || perm.acesso === 1
      ),
    }
  })
}

export const agruparPermissoesPorModulo = (permissoes, modulos) => {
  if (!permissoes || !modulos) return []

  const modulos_com_permissoes = modulos.map((modulo) => {
    return {
      ...modulo,
      permissoes: permissoes.filter((permissao) => {
        return (
          (permissao?.cod_modulo && permissao.cod_modulo === modulo.cod_modulo) ||
          (permissao?.modulo_nome && permissao.modulo_nome === modulo.modulo_nome) ||
          (permissao?.cod_modulo_rotina && permissao.cod_modulo_rotina === modulo.cod_modulo)
        )
      }),
    }
  })
  
  // Retorna apenas os modulos que tiverem permissões vinculadas
  return modulos_com_permissoes.filter(modulo => modulo.permissoes && modulo.permissoes.length > 0)
}

// Cores temáticas do Ant Design Tag para cada módulo
const CORES_MODULOS: Record<string, string> = {
  'agricultura de precisão': 'green',
  'análise agronômica': 'lime',
  'atividades': 'blue',
  'cadastros base': 'cyan',
  'equipe': 'purple',
  'fornecedores': 'orange',
  'monitoramento': 'geekblue',
  'patrimônio': 'gold',
  'propriedades': 'volcano',
  'regulagens': 'magenta',
  'safra': 'green',
  'clima': 'cyan',
  'pragas e doenças': 'red',
  'visualização de mapa': 'blue',
  'equipe de campo': 'purple',
  'financeiro': 'gold',
  'relatórios': 'geekblue',
  'configurações': 'default',
  'solo': 'volcano',
  'plantas': 'lime',
  'raízes': 'orange',
}

const CORES_FALLBACK = ['green', 'blue', 'purple', 'cyan', 'gold', 'magenta', 'volcano', 'geekblue', 'lime', 'orange']

export const corDoModulo = (nomeModulo: string): string => {
  if (!nomeModulo) return 'green'
  const nomeLower = nomeModulo.toLowerCase().trim()

  // Primeiro tenta match exato
  if (CORES_MODULOS[nomeLower]) return CORES_MODULOS[nomeLower]

  // Depois tenta match parcial
  for (const [chave, cor] of Object.entries(CORES_MODULOS)) {
    if (nomeLower.includes(chave) || chave.includes(nomeLower)) return cor
  }

  // Fallback: gera uma cor consistente baseada no hash do nome
  let hash = 0
  for (let i = 0; i < nomeLower.length; i++) {
    hash = nomeLower.charCodeAt(i) + ((hash << 5) - hash)
  }
  return CORES_FALLBACK[Math.abs(hash) % CORES_FALLBACK.length]
}
